import React, { useEffect, useState } from "react";
import CustomLoader from "../../../../common/CustomLoader";
import { useAISocialMediaContext } from "../../../../../context/ai-social-media.context";
import AdImageItem from "./components/AdImageItem";
import AdWidget from "./components/AdWidget";

const SocialFinalAdtWidget = () => {
  const { adContent } = useAISocialMediaContext();

  const renderAdWidgetList = () => {
    if (adContent && adContent.length) {
      return adContent.map((item, index) => (
        <AdWidget key={index} widget={item} rowIndex={index} />
      ));
    }
  };

  const renderAdWidget = () => {
    if (adContent && adContent.length) {
      return (
        <div className="bg-white box-shadow rounded p-5">
          {renderAdWidgetList()}
        </div>
      );
    }
    return (
      <div className="d-flex justify-content-center">
        <CustomLoader masked />
      </div>
    );
  };

  const render = () => {
    return (
      <>
        <h3 className="mb-3">Final Ads</h3>
        {renderAdWidget()}
      </>
    );
  };
  return render();
};

export default SocialFinalAdtWidget;
